export enum RouteIds {
  course = 'course',
  extras = 'extras',
  applicant = 'applicant',
  quote = 'quote',
  ayaQuote = 'aya-quote',
  booking = 'booking',
  confirmation = 'confirmation',
  payment = 'payment',
}
